import React, { useState } from "react";
import { Handle } from "./styles";

/**
 * Alça de redimensionamento. Posicionada absolutamente na borda direita
 * do <th> pai (que precisa ter `position: relative` ou `sticky`).
 */
export default function ResizeHandle({ onPointerDown, onDoubleClick }) {
  const [dragging, setDragging] = useState(false);

  const handlePointerDown = (e) => {
    setDragging(true);
    const stopDragging = () => {
      setDragging(false);
      document.removeEventListener("pointerup", stopDragging);
      document.removeEventListener("pointercancel", stopDragging);
    };
    document.addEventListener("pointerup", stopDragging);
    document.addEventListener("pointercancel", stopDragging);
    if (onPointerDown) onPointerDown(e);
  };

  return (
    <Handle
      data-dragging={dragging ? "true" : undefined}
      onPointerDown={handlePointerDown}
      onDoubleClick={(e) => {
        e.stopPropagation();
        if (onDoubleClick) onDoubleClick(e);
      }}
      onClick={(e) => e.stopPropagation()}
      aria-hidden="true"
    />
  );
}
